import { type ReactNode } from "react";
import { ChatConversationContext, type ChatConversationRuntime } from "./chatConversationContext";

export type ChatConversationProviderProps = {
    value: ChatConversationRuntime;
    children: ReactNode;
};

export const ChatConversationProvider = ({
    value,
    children
}: ChatConversationProviderProps) => (
    <ChatConversationContext.Provider value={value}>
        {children}
    </ChatConversationContext.Provider>
);
